/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Not_Found_DescInputs */

const vi_trace_not_found_desc = /** @type {(inputs: Trace_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã truy xuất không tồn tại hoặc đã bị vô hiệu hóa.`)
};

/**

* @param {Trace_Not_Found_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_not_found_desc = /** @type {((inputs?: Trace_Not_Found_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Not_Found_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_not_found_desc(inputs)
});